<mat-card appearance="outlined">
  <div class="header">
    <h2>{{ 'dynamicContent.eventDates.title' | translate }}</h2>
    <ibex-checkbox *ngIf="superadmin" (click)="toggleRepeating($event);" [checked]="!!dynamicContent.content.repeating"
                   [title]="'dynamicContent.activity.repeating' | translate"></ibex-checkbox>
  </div>

  <ng-container *ngIf="dynamicContent.content.repeating && dynamicContent.content.repetition">
    <div class="flex-group">
      <smart-input (onChange)="updateDescription()" [(model)]="dynamicContent.content.repetition" key="startDate" translationPrefix="dynamicContent" #startDate></smart-input>
      <smart-input *ngIf="dynamicContent.content.repetition.repetitionSize !== 'day'" (onChange)="updateDescription()" [(model)]="dynamicContent.content.repetition" key="endDate" translationPrefix="dynamicContent"></smart-input>
    </div>
    <div class="flex-group">
      <smart-input (onChange)="updateDescription()" [(model)]="dynamicContent.content.repetition" key="startTime" translationPrefix="dynamicContent"></smart-input>
      <smart-input (onChange)="updateDescription()" [(model)]="dynamicContent.content.repetition" key="endTime" translationPrefix="dynamicContent"></smart-input>
    </div>
    <div class="flex-group">
      <smart-input (onChange)="updateDescription()" *ngIf="dynamicContent.content.repetition?.repetitionSize !== 'year'" [(model)]="dynamicContent.content.repetition" key="repetitionRhythm" translationPrefix="dynamicContent"></smart-input>
      <smart-input (onChange)="updateDescription();updateRepetitionSize()" [(model)]="dynamicContent.content.repetition" key="repetitionSize" translationPrefix="dynamicContent.repetitionSize"></smart-input>
    </div>
    <div class="flex-group days" *ngIf="dynamicContent.content.repetition?.repetitionSize === 'week' || (dynamicContent.content.repetition?.repetitionSize === 'day' && dynamicContent.content.repetition?.repetitionRhythm === '1')">
      <ibex-checkbox *ngFor="let i of weekdayArray" (click)="updateDays(i)" [title]="'general.days.' + i | translate" [checked]="weekdays[i]"></ibex-checkbox>
    </div>
    <div class="flex-group days" *ngIf="dynamicContent.content.repetition?.repetitionSize === 'month' || dynamicContent.content.repetition?.repetitionSize === 'year'">
      <ibex-checkbox (click)="toggleRepetitionExact($event)" id="repetitionExact" [title]="getExactTitle()" [checked]="dynamicContent.content.repetition.repetitionExact && !dynamicContent.content.repetition.repetitionLastDay"></ibex-checkbox>
      <ibex-checkbox (click)="toggleRepetitionExact($event)" id="repetitionClose" [title]="getExactTitle('close')" [checked]="!dynamicContent.content.repetition.repetitionExact && !dynamicContent.content.repetition.repetitionLastDay"></ibex-checkbox>
      <ibex-checkbox *ngIf="isLastOfMonth()" (click)="toggleRepetitionLastDay()" title="Findet am letzten Tag des Monats statt." [checked]="!!dynamicContent.content.repetition.repetitionLastDay"></ibex-checkbox>
    </div>

    <div class="description" *ngIf="dynamicContent.content.repetition?.repetitionSize === 'week' || dynamicContent.content.repetition?.repetitionSize === 'day'">{{description}}</div>

    <!--<div class="flex-group">
      <smart-input [(model)]="dynamicContent.content.repetition" key="seriesEndDate" translationPrefix="dynamicContent" #seriesEndDate></smart-input>
    </div>-->
  </ng-container>

  <ng-container *ngIf="!dynamicContent.content.repeating">
    <div class="main-actions">
      <button (click)="add()" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.eventDates.add' | translate }}</button>
    </div>
    <div class="table-header">
      <div class="content">{{ 'dynamicContent.startDate' | translate }}</div>
      <div class="content">{{ 'dynamicContent.startTime' | translate }}</div>
      <div class="content">{{ 'dynamicContent.endDate' | translate }}</div>
      <div class="content">{{ 'dynamicContent.endTime' | translate }}</div>
      <div class="actions"></div>
    </div>
    <div class="table" *ngIf="dynamicContent?.content?.multipleDates?.length">
      <div *ngFor="let item of dynamicContent.content.multipleDates; let i = index" class="table-row">
        <div class="content">{{ item?.startDate | date: 'dd.MM.yyyy' }}</div>
        <div class="content">{{ item?.startTime }}</div>
        <div class="content">{{ item?.endDate | date: 'dd.MM.yyyy' }}</div>
        <div class="content">{{ item?.endTime }}</div>
        <div class="actions">
          <button (click)="edit(i)" class="ibexfusion-icon-button" mat-icon-button><mat-icon>edit</mat-icon></button>
          <button (click)="remove(i)" class="ibexfusion-icon-button" mat-icon-button><mat-icon>delete</mat-icon></button>
        </div>
      </div>
    </div>

    <p *ngIf="!dynamicContent?.content?.multipleDates?.length" class="no-file">{{ 'dynamicContent.noDates' | translate }}</p>
  </ng-container>

</mat-card>
